import React from 'react';
import { ReactComponent as Logo } from '../../assets/mainLogo.svg';
import Button, { ButtonMedium } from '../../components/Button';
import styles from './styles.module.scss';
import { ReactComponent as Main } from './assets/main_image.svg';
import { ReactComponent as Reload } from './assets/reload.svg';
import appStore from '../../store/App';

interface ErrorProps {
  onReset?: () => void;
}

const Error: React.FC<ErrorProps> = ({ onReset }) => {
  const handleTryAgain = () => {
    // Сбрасываем ошибку и пытаемся продолжить работу
    appStore.isError = false;
    // Сбрасываем состояние ErrorBoundary если передана функция
    if (onReset) {
      onReset();
    }
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className={styles.container}>
      <Logo />
      <div className={styles.holder}>
        <div className={styles.main}>
          <Main />
          <p className={styles.text}>
            Что-то пошло не так. Данные не были загружены.
            <br />
            Попробуйте продолжить работу или перезагрузите страницу.
          </p>
          <div
            style={{ display: 'flex', gap: '12px', flexDirection: 'column' }}
          >
            <ButtonMedium onClick={handleTryAgain}>
              Попробовать снова
            </ButtonMedium>
            <ButtonMedium renderIcon={() => <Reload />} onClick={handleReload}>
              Перезагрузить страницу
            </ButtonMedium>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error;
